import { render } from "./FormMatrix.vue?vue&type=template&id=551f5c8e&scoped=true"
import script from "./FormMatrix.vue?vue&type=script&lang=js"
export * from "./FormMatrix.vue?vue&type=script&lang=js"

import "./FormMatrix.vue?vue&type=style&index=0&id=551f5c8e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-551f5c8e"]])

export default __exports__